import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss']
})
export class ProgressComponent {

  @Input() progress!: number;

  getProgressStyle() {
    let style: any = {
      height: `${this.progress}%`
    }

    return style;
  }
}
